export const goodsGroupRouterList = [{
  path: '/product/department/BasicInfo',
  name: 'DepartmentBasicInfo',
  component: () => import('@/views/product/productGroup/department/DepartmentBasicInfo'),
  meta: {
    title: '百货-基础信息',
    keepAlive: false
  }
},
  {
    path: '/product/department/priceSet',
    name: 'DepartmentPriceSet',
    component: () => import('@/views/product/productGroup/department/DepartmentPriceSet'),
    meta: {
      title: '百货-新增套餐与价格',
      keepAlive: false
    }
  },
  {
    path: '/product/department/priceSetting',
    name: 'DepartmentPriceSetting',
    component: () => import('@/views/product/productGroup/department/DepartmentPriceSetting'),
    meta: {
      title: '百货-新增套餐与价格',
      keepAlive: false
    }
  },
  {
    path: '/product/hotel/BasicInfo',
    name: 'HotelBasicInfo',
    component: () => import('@/views/product/productGroup/hotel/HotelBasicInfo'),
    meta: {
      title: '酒店-基础信息',
      keepAlive: false
    }
  }, {
    path: '/product/hotel/bookSet',
    name: 'HotelBookSet',
    component: () => import('@/views/product/productGroup/hotel/HotelBookSet'),
    meta: {
      title: '酒店-预订设置',
      keepAlive: false
    }
  }, {
    path: '/product/hotel/optionInfo',
    name: 'HotelOptionInfo',
    component: () => import('@/views/product/productGroup/hotel/HotelOptionInfo'),
    meta: {
      title: '酒店-房型信息',
      keepAlive: false
    }
  }, {
    path: '/product/option/list',
    name: 'OptionList',
    component: () => import('@/views/product/productGroup/components/OptionList'),
    meta: {
      title: '列表',
      keepAlive: false
    }
  }, {
    path: '/product/option/hotleList',
    name: 'HotelOptionList',
    component: () => import('@/views/product/productGroup/hotel/HotelOptionList'),
    meta: {
      title: '列表',
      keepAlive: false
    }
  }, {
    path: '/product/hotel/plan',
    name: 'HotelPricePlan',
    component: () => import('@/views/product/productGroup/hotel/HotelPricePlan'),
    meta: {
      title: '酒店-价格计划',
      keepAlive: false
    }
  }, {
    path: '/product/hotel/planInfo',
    name: 'HotelPlanInfo',
    component: () => import('@/views/product/productGroup/hotel/HotelPlanInfo'),
    meta: {
      title: '酒店-价格计划信息',
      keepAlive: false
    }
  }, {
    path: '/product/option/ownPrice',
    name: 'ProOwnPrice',
    component: () => import('@/views/product/productGroup/components/ProOwnPrice'),
    meta: {
      title: '商品-价格设置',
      keepAlive: false
    }
  }, {
    path: '/product/option/calendar',
    name: 'NewProCalendar',
    component: () => import('@/views/product/productGroup/components/NewProCalendar'),
    meta: {
      title: '商品-价格设置',
      keepAlive: false
    }
  }, {
    path: '/product/option/noOwnPrice',
    name: 'ProNoOwnPrice',
    component: () => import('@/views/product/productGroup/components/ProNoOwnPrice'),
    meta: {
      title: '分销商品-价格设置',
      keepAlive: false
    }
  }, {
    path: '/product/tickets/BasicInfo',
    name: 'TicketsBasicInfo',
    component: () => import('@/views/product/productGroup/tickets/TicketsBasicInfo'),
    meta: {
      title: '门票-基础信息',
      keepAlive: false
    }
  }, {
    path: '/product/tickets/optionInfo',
    name: 'TicketsOptionInfo',
    component: () => import('@/views/product/productGroup/tickets/TicketsOptionInfo'),
    meta: {
      title: '门票-票型信息',
      keepAlive: false
    }
  }, {
    path: '/product/presell/BasicInfo',
    name: 'PresellBasicInfo',
    component: () => import('@/views/product/productGroup/presell/PresellBasicInfo'),
    meta: {
      title: '抢购-基础信息',
      keepAlive: false
    }
  }, {
    path: '/product/presell/book',
    name: 'PresellBookSet',
    component: () => import('@/views/product/productGroup/presell/PresellBookSet'),
    meta: {
      title: '抢购-预订设置',
      keepAlive: false
    }
  }, {
    path: '/product/presell/prcie',
    name: 'PresellPriceSet',
    component: () => import('@/views/product/productGroup/presell/PresellPriceSet'),
    meta: {
      title: '抢购-价格库存',
      keepAlive: false
    }
  }, {
    path: '/product/scenicHotel/optionInfo',
    name: 'ScenicOptionInfo',
    component: () => import('@/views/product/productGroup/scenicHotel/ScenicOptionInfo'),
    meta: {
      title: '景酒-套餐信息',
      keepAlive: false
    }
  }, {
    path: '/product/scenicHotel/BasicInfo',
    name: 'ScenicHotelBasicInfo',
    component: () => import('@/views/product/productGroup/scenicHotel/ScenicHotelBasicInfo'),
    meta: {
      title: '景酒-基础信息',
      keepAlive: false
    }
  },
  {
    path: '/product/tour/BasicInfo',
    name: 'TourBasicInfo',
    component: () => import('@/views/product/productGroup/tour/TourBasicInfo'),
    meta: {
      title: '跟团-基础信息',
      keepAlive: false
    }
  },
  {
    path: '/product/tour/itineraryInformation',
    name: 'ItineraryInformation',
    component: () => import('@/views/product/productGroup/tour/ItineraryInformation'),
    meta: {
      title: '跟团-行程信息',
      keepAlive: false
    }
  },
  {
    path: '/product/tour/presaleSetting',
    name: 'PresaleSetting',
    component: () => import('@/views/product/productGroup/tour/PresaleSetting'),
    meta: {
      title: '跟团-抢购设置',
      keepAlive: false
    }
  },
  {
    path: '/product/travel/BasicInfo',
    name: 'TravelBasicInfo',
    component: () => import('@/views/product/productGroup/travel/TravelBasicInfo'),
    meta: {
      title: '自由行-基础信息',
      keepAlive: false
    }
  }, {
    path: '/product/travel/proDes',
    name: 'TravelProDes',
    component: () => import('@/views/product/productGroup/travel/TravelProDes'),
    meta: {
      title: '自由行-商品信息',
      keepAlive: false
    }
  }, {
    path: '/product/visa/BasicInfo',
    name: 'VisaBasicInfo',
    component: () => import('@/views/product/productGroup/visa/VisaBasicInfo'),
    meta: {
      title: '签证-基础信息',
      keepAlive: false
    }
  }, {
    path: '/product/visa/proDes',
    name: 'VisaProDes',
    component: () => import('@/views/product/productGroup/visa/VisaProDes'),
    meta: {
      title: '签证-商品详情',
      keepAlive: false
    }
  }, {
    path: '/product/visa/price',
    name: 'VisaProPrice',
    component: () => import('@/views/product/productGroup/visa/VisaProPrice'),
    meta: {
      title: '签证-价格设置',
      keepAlive: false
    }
  }, {
    path: '/product/option/succee',
    name: 'SucceedPage',
    component: () => import('@/views/product/productGroup/components/SucceedPage'),
    meta: {
      title: '商品-发布并上架',
      keepAlive: false
    }
  }]